import {
  CaretakerLocation,
  CaretakerLocationDto,
} from '$domain/model/caretaker/caretakersLocation/caretakersLocation.model'

export const mapToCaretakersLocation = (caretakersLocation: CaretakerLocationDto[]): CaretakerLocation[] =>
  caretakersLocation.map(caretakerLocation => {
    return {
      caretakerId: caretakerLocation.caretakerId ? caretakerLocation.caretakerId : '',
      name: caretakerLocation.name ? caretakerLocation.name : '',
      latitude: caretakerLocation.latitude ? caretakerLocation.latitude : 0,
      longitude: caretakerLocation.longitude ? caretakerLocation.longitude : 0,
      hasActiveProSubscription: caretakerLocation.hasActiveProSubscription
        ? caretakerLocation.hasActiveProSubscription
        : false,
      isVerified: caretakerLocation.isVerified ? caretakerLocation.isVerified : false,
    }
  })

export const mapCaretakerAvailableCareType = (caretakerAvailableCareType: string[]): string => {
  if (caretakerAvailableCareType && caretakerAvailableCareType.length > 0) {
    return caretakerAvailableCareType.toString()
  }

  return ''
}



// WEBPACK FOOTER //
// ./src/domain/model/caretaker/caretakersLocation/caretakersLocation.mapper.ts